export default "__VITE_ASSET__Ci2$TVIu__"